const TOKEN_KEY = 'salary_system_token'
const USER_INFO_KEY = 'salary_system_user_info'

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function setUserInfo(userInfo) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

export function getUserInfo() {
  const info = localStorage.getItem(USER_INFO_KEY)
  if (info) {
    try {
      return JSON.parse(info)
    } catch (e) {
      return null
    }
  }
  return null
}

export function removeUserInfo() {
  localStorage.removeItem(USER_INFO_KEY)
}

export function clear() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}